<template>
  <loading :loading="isLoading" message="Busy stealing that notification">
    <error :error="error"/>
    <b-form-group label="Notification URI" description="Get this from the address bar when viewing the notification (ignoring the `/alerts/` prefix).">
      <b-form-input id="steal"
        v-model.trim="stealFromUri"
        type="text"
        required
        placeholder="electoral_roll_multiple_spd/1 ELM STREET|RG6 5JJ"></b-form-input>
    </b-form-group>
    <b-form-group label="The authority to steal this from (the same URI may apply to multiple authorities).">
      <b-form-input id="auth"
        v-model.trim="stealFromAuthority"
        type="text"
        required
        placeholder="castlepoint"></b-form-input>
    </b-form-group>
    <b-button variant="danger" @click="cloneNotification" class="card-link">Steal now</b-button>
  </loading>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'

export default {
  components: { Loading, Error },
  data() {
    return {
      isLoading: false,
      error: null,
      stealFromUri: null,
      stealFromAuthority: 'chelmsford',
    };
  },
  methods: {
    validated() {
      this.error = null;
      // required
      if ((this.stealFromUri || '').length === 0) {
        this.error = "Notification URI is required";
        return false;
      }
      if ((this.stealFromAuthority || '').length === 0) {
        this.error = "Authority is required";
        return false;
      }
      // clean
      if (this.stealFromUri.indexOf('alerts/') !== -1) {
        this.stealFromUri = this.stealFromUri.substring('/alerts/'.length);
      }
      // trim slash prefixes
      while (this.stealFromUri.indexOf('/') === 0) {
        this.stealFromUri = this.stealFromUri.substring(1);
      }
      // trim hash prefixes
      while (this.stealFromUri.indexOf('#') === 0) {
        this.stealFromUri = this.stealFromUri.substring(1);
      }
      return true;
    },

    cloneNotification() {
      if (!this.validated()) {
        return;
      }
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'StealNotification',
        parameters: {
          authority: this.stealFromAuthority,
          alert_uri: this.stealFromUri,
        },
      })
      .then(() => {
        this.$store.dispatch('invalidateCache', 'alerts');
        this.$store.dispatch('invalidateCache', 'home');
        this.$router.push(`/alerts/${this.stealFromUri}`);
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
  },
};
</script>
